function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 1C17.5717 1 16.6815 1.36875 16.0251 2.02513C15.3687 2.6815 15 3.57174 15 4.5V18.5C15 19.4283 15.3687 20.3185 16.0251 20.9749C16.6815 21.6313 17.5717 22 18.5 22C19.4283 22 20.3185 21.6313 20.9749 20.9749C21.6313 20.3185 22 19.4283 22 18.5C22 17.5717 21.6313 16.6815 20.9749 16.0251C20.3185 15.3687 19.4283 15 18.5 15H4.5C3.57174 15 2.6815 15.3687 2.02513 16.0251C1.36875 16.6815 1 17.5717 1 18.5C1 19.4283 1.36875 20.3185 2.02513 20.9749C2.6815 21.6313 3.57174 22 4.5 22C5.42826 22 6.3185 21.6313 6.97487 20.9749C7.63125 20.3185 8 19.4283 8 18.5V4.5C8 3.57174 7.63125 2.6815 6.97487 2.02513C6.3185 1.36875 5.42826 1 4.5 1C3.57174 1 2.6815 1.36875 2.02513 2.02513C1.36875 2.6815 1 3.57174 1 4.5C1 5.42826 1.36875 6.3185 2.02513 6.97487C2.6815 7.63125 3.57174 8 4.5 8H18.5C19.4283 8 20.3185 7.63125 20.9749 6.97487C21.6313 6.3185 22 5.42826 22 4.5C22 3.57174 21.6313 2.6815 20.9749 2.02513C20.3185 1.36875 19.4283 1 18.5 1Z",
  stroke: "#431288",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgApplicantsicon = function SvgApplicantsicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApplicantsicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/applicantsicon.f6f4a63b.svg";
export { ForwardRef as ReactComponent };